import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Optimum,
  Astound,
  WOW,
  TDS,
  BuckeyeBroadband,
  Mediacom,
  ATT,
  BrightspeedV2,
  QuantumFiber,
  CenturyLink,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  Earthlink,
} from 'config/providers';
import { XfinityTheme } from 'config/themes';

export const AdAction: SingleProviderConfig = {
  name: 'AdAction',
  micrositeCode: 'adaction',
  mainProvider: Comcast,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'xfinityspecial.com',
  homepage: 'https://xfinityspecial.com',
  title: 'Xfinity Authorized Dealer',
  fallbackPhoneNumber: '833-288-4509',
  fallbackLeadModePhoneNumber: '833-288-4505',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: XfinityTheme,
  needsDcSession: true,
  source: 'Xfinity',
  noOffersRetry: 2,
  commercialHomepage: 'https://comcastbusinessspecial.com',
  getCrossSellAction: getDefaultCrossSellAction,
  crossSellProviders: [
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Astound,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    BrightspeedV2,
    QuantumFiber,
    CenturyLink,
    Frontier,
    Windstream,
    CincinnatiBell,
    Verizon,
    Earthlink,
  ],
  // TODO: async broken by legacy GBF removal
  // will be restored when migrated to config tool, once call center is ready
  getCheckoutType: asyncEligible,
};
